module.exports = __webpack_public_path__ + "static/Arik-hex-9022125ee3391d68cb270b5e172f8f97.png";